import React from 'react';
import '../../assets/css/Terminos.css';
import logo from '../../assets/cabal.png';

const Terminos = () => {
  return (
    <div className="Terminos">
      <div className="div-content">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row-reverse'
          }}
        >
          <img src={logo} className="Terminos-logo" alt="logo" />
        </div>
      </div>

      <p className="text-title" style={{ fontWeight: 'bold' }}>
        Términos y condiciones
      </p>
      
      <div className="div-content">
        <p className="text-title-fecha">
          ANEXO AL CONTRATO DE CONDICIONES GENERALES PARA LA PRESTACIÓN DEL SERVICIO ENTRE LA COOPERATIVA BINACIONAL DE SERVICIOS CABAL PARAGUAY LTDA. CABAL/PISP Y EL COMERCIO ADHERIDO.
        </p>
      </div>


      <div className="div-content">
        <p>
          La <b>“COOPERATIVA BINACIONAL DE SERVICIOS CABAL PARAGUAY LTDA.”</b>, con R.U.C. 80019564-7 en adelante denominada <b>“CABAL/PISP” Y EL COMERCIO</b>, cuyos datos de identificación y contacto, así como el lugar y fecha del presente, se consignan en los campos correspondiente, acuerdan en celebrar el presente Anexo al contrato principal suscrito anteriormente por ambas partes y al cual se agrega por este instrumento los términos y condiciones que regirán en adelante para la prestación del servicio a través del <b>Sistema de Pagos Instantáneos (SPI)</b>, en base a las siguientes cláusulas.

        </p>
      </div>

      <p className="text-title">CLAUSULA PRIMERA. DEFINICIONES</p>
      <div className="div-content">
        <p>
          <b>“SISTEMA DE PAGOS INSTANTÁNEOS (SPI)”</b>: Es un sistema que procesa pagos, en el que la transmisión del mensaje de pago y la disponibilidad de los fondos finales al beneficiario se produce en tiempo real, durante las 24 horas del día, los 7 días de la semana. La liquidación final en la cuenta de los Participantes se realiza a través de un proceso de compensación en el LBTR de conformidad a las reglas operativas emitidas sobre dicho servicio.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b>“PROVEEDOR DE SERVICIO DE INICIO DE PAGOS (PISP)”</b>: es un tipo de participante que está registrado y posee conexión directa al SPI, pero no tiene cuenta de posición en el SPI, ni cuenta de liquidación ni de reserva en la LBTR. Este tipo de participante provee un servicio para solicitar el inicio de un pago.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b>“SIPAP”</b>: Sistemas de Pagos del Paraguay, administrado por el Banco Central del Paraguay.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b>"CABAL PARAGUAY LTDA."</b> es una entidad Cooperativa constituida bajo las leyes de la República del Paraguay, que tiene conexión directa al SPI y se encuentra registrada como PISP.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b>“EL COMERCIO”</b> entidad adherida a CABAL PARAGUAY LTDA. y que a través del servicio que esta le presta, accede al Sistema de Pagos Instantáneos (SPI).
        </p>
      </div>

      <div className="div-content">
        <p>
          <b>“USUARIO FINAL”</b> persona vinculada a EL COMERCIO y que accede a través de ella al SPI.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA SEGUNDA. OBJETO:</b> El presente contrato tiene por objeto poner a disposición de EL COMERCIO una herramienta que le permita operar en el Sistema de Pagos Instantáneos (SPI) y que será activada por CABAL en su carácter de Proveedora de Servicio de Inicio de Pagos (PISP) debidamente registrada en ante el Banco Central del Paraguay.<br />
          Este procedimiento se desarrollará dentro del Sistema de Pagos del Paraguay (SIPAP).
        </p>
      </div>


      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA TERCERA. TARIFARIO:</b> La prestación del servicio estará sujeta a la tarifa indicada en la Resolución N°18 Acta N°42, de fecha 13 de setiembre del 2023 emitida por el Banco Central del Paraguay. Asimismo, EL COMERCIO autoriza a CABAL a percibir el cobro de las comisiones por el servicio prestado, a ser aplicado a las diferentes opciones de cobranzas.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA CUARTA. RESPONSABILIDADES DE CABAL/PISP:</b> CABAL PARAGUAY LTDA garantiza la implementación de operaciones dentro del SPI, no así el funcionamiento adecuado del sistema que está a cargo del Banco Central del Paraguay.
        </p>
      </div>

      <div className="div-content">
        <p>
          CABAL no asumirá responsabilidad alguna por el mal funcionamiento del Centro de Cómputos y/o Programas del Centro de Autorizaciones de EL COMERCIO ni por interrupciones del servicio de energía eléctrica, y/o telefónico, y/o casos fortuitos o de fuerza mayor debidamente comprobados.
        </p>
      </div>

      <div className="div-content">
        <p>
          CABAL declara que todos los diseños, patentes, marcas registradas, know-how, secretos de comercialización, y cualesquiera otros datos e informaciones utilizados, directa o indirecta, para la ejecución del objeto de este contrato, son de su exclusiva propiedad o, según el caso, de sus empresas controlantes, controladas o afiliadas o, aun siendo de propiedad de terceros, posee ella las autorizaciones debidas y permisos legales para su utilización.
        </p>
      </div>

      <div className="div-content">
        <p>
          EL COMERCIO declara y acepta expresamente que las operaciones ordenadas en el SPI por los usuarios del servicio, serán de su exclusiva responsabilidad, no generando responsabilidad alguna para CABAL PARAGUAY LTDA. por cualquier causa o concepto, ni por los problemas de funcionamiento derivados de su incorrecta operación o por cualquier otro motivo que pudiera vincularse directa o indirectamente con la prestación de aquellos servicios que brinda a sus usuarios, así como cualquier falla técnica de los equipos de computación, redes, alimentación deficiente de energía o cualquier otro factor que le fuera ajeno y que alterase los procesos o sus resultados.
        </p>
      </div>

      <div className="div-content">
        <p>
          EL COMERCIO deslinda a CABAL PARAGUAY LTDA de toda responsabilidad por cualquier accidente, daño o perjuicio que pueda ocurrir al operar en el SPI y/o los servicios que EL COMERCIO ofrece a los usuarios, así como deberá mantener indemne de los reclamos o demandas de los usuarios y/o de terceros, que pudieran generarse con motivo o por causa de la prestación de los servicios, debiendo ejercer en su nombre las defensas y/o acciones que en derecho pudiera presentarse, asumiendo los costos y costas legales y/o judiciales, incluyendo los honorarios de los profesionales abogados que deban ejercer esas defensas y/o acciones siempre y cuando los accidentes, daños o perjuicios no hayan tenido origen en la negligencia de CABAL PARAGUAY LTDA.
        </p>
      </div>

      <div className="div-content">
        <p>
          En caso de ocurrir alguno de los hechos previstos en las cláusulas que preceden, EL COMERCIO deberá comunicar por escrito a CABAL PARAGUAY LTDA, a más tardar dentro de las 48 horas de haber tenido conocimiento del hecho del que se trate, informando de los pasos a seguir como así también de los distintos actos que vayan sucediendo.
        </p>
      </div>

      <div className="div-content">
        <p>
          CABAL PARAGUAY LTDA, así como sus empleados, entidades socias, representantes, gerentes y/o miembros del Consejo de Administración, no asumen responsabilidad alguna si por cualquier causa el SPI no funciona temporalmente por razones no imputables a la misma o por cualquier falla técnica de los equipos de computación, redes, internet, alimentación deficiente de energía o cualquier otro factor que le fuera ajeno. El SPI y otros sistemas están diseñados para prestar determinados servicios a las personas, pero como toda tecnología, el Software y/o el Sistema pueden fallar por razones inesperadas. EL COMERCIO declara aceptar y conocer expresamente la presente cláusula, y asume la responsabilidad de informar a los usuarios por medio escrito de esta cláusula.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA QUINTA: CUMPLIMIENTO REGULATORIO.</b><br />
          Las partes manifiestan conocer y se obligan a cumplir con las resoluciones emitidas por el Banco Central del Paraguay que afecten al servicio “Proveedores de Servicio de Inicio de Pagos (PISP)” incluidas las normas de seguridad tecnológica. De igual manera ambas partes se comprometen a mantenerse actualizados a las resoluciones futuras emitidas por el BCP que puedan afectar a dicho servicio.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA SEXTA. PROTECCION DE DATOS PERSONALES Y FINANCIEROS</b><br />
          Cada Parte se obliga a manejar confidencialmente todos los datos que obtenga de la otra parte, ya sea información relacionada a los socios, clientes, usuarios finales, códigos otorgados, procedimientos de seguridad u otros, los cuales no pueden ser exhibidos a ninguna otra persona, salvo expresa autorización de la Parte afectada u orden judicial.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA SEPTIMA. POLITICA DE PRIVACIDAD</b><br />
          CABAL se compromete a mantener la privacidad en la recopilación, utilización y protección de la información personal y financiera de EL COMERCIO y del Usuario Final.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA OCTAVA. RESCISION DEL CONTRATO</b><br />
          Cualquiera de las Partes podrá dar por finalizado el presente Contrato por escrito y en forma fehaciente con una antelación de 30 (treinta) días en cuyo caso quedarán obligadas a cumplir las disposiciones del mismo hasta el día de rescisión. La rescisión así declarada no dará derecho a reclamar indemnización a ninguna de las partes.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA NOVENA. TERMINACION</b><br />
          El presente documento quedará rescindido sin previo aviso y sin efecto si ocurriere cualquiera de las siguientes eventualidades:
        </p>

        <p>
          - Que cualquiera de las partes, soliciten Convocación de sus Acreedores y/o sea declarada su quiebra.
        </p>
        <p>
          - Que se produjere el incumplimiento de cualquiera de las condiciones del contrato y esta Adenda.
        </p>
        <p>
          - Ambas partes deberán dar cumplimiento a sus obligaciones antes asumidas hasta la fecha efectiva de la rescisión.
        </p>
      </div>

      <div className="div-content">
        <p>
          <b style={{ textDecoration: 'underline' }}>CLAUSULA DECIMA. LEY APLICABLE. JURISDICCION.</b><br />
          El presente Contrato se regirá por las leyes de la República del Paraguay.<br />
          Las Partes acuerdan someter cualquier controversia que surja de la ejecución de este acuerdo o tenga relación con el mismo, con su interpretación, validez o invalidez, que no pueda ser resuelta por negociación directa en las Partes, a la jurisdicción y competencia de los Juzgados y Tribunales de la Ciudad de Asunción, República del Paraguay.<br />
          TODAS las demás condiciones generales del contrato principal que regula la prestación de servicios entre CABAL y EL COMERCIO, se mantienen con plena vigencia y validez.
        </p>
      </div>








      <p className="text-title" style={{ color: 'black' }}>FIRMAS:</p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <div className="div-content">
        <div style={{
          borderBottom: '1px solid black',
          width: '100%',
        }} />
      </div>
      <p className="text-title" style={{ color: 'black' }}>COOPERATIVA BINACIONAL DE SERVICIOS CABAL PARAGUAY LTDA.</p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <div className="div-content">
        <div style={{
          borderBottom: '1px solid black',
          width: '100%',
        }} />
      </div>
      <p className="text-title" style={{ color: 'black' }}>EL COMERCIO</p>




    </div>
  );
};
export default Terminos;
